var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPositive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    style: {
      enableBackground: "new 0 0 51 51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D9D9D9;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#6644F1;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#605E78;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#605E78;stroke-width:2;stroke-miterlimit:10;}\n\t.st4{fill:#6644F1;}\n\t.st5{fill:#453E61;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#453E61;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.9,0.3c0,0-6.7,1.5-7.8,7.7c-1.1,6.2-0.1,9.4-0.1,9.4l2.9,6.1l2.4-0.4c-0.9-3.8-1.2-4.4-1.5-9.4 c0.2-2.9,0.5-4.2,0.9-6.2C130.4,4.3,131.9,1.8,132.9,0.3L132.9,0.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.9,22.6c0,0-6.7,1.5-7.8,7.5c-1.1,6.1-0.1,9.2-0.1,9.2l2.9,6l5.1,3.3c-2-2.7-3.1-5.8-3.7-9.3 c-0.4-2.7-0.4-5.4,0.2-8c0.1-0.5,0.2-1.1,0.4-1.7C130.4,26.5,131.9,24.1,132.9,22.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.5,16.6c-2.4-0.1-3.9,2-4,2.2c-0.3,0.5-0.9,0.5-1.3,0.2c-0.4-0.3-0.5-1-0.2-1.4c0.2-0.3,2.2-3.1,5.5-3 c3.2,0.1,5,2.6,5.2,2.9c0.3,0.4,0.2,1.1-0.2,1.4c-0.4,0.4-1,0.3-1.3-0.2C143.2,18.5,141.8,16.6,139.5,16.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.3,9.5c0,0-6.6,1.5-7.7,7.7c-1.5,6.1-1,9.4-1,9.4l3.7,6.1l5,3.3c-1.9-2.8-3.1-5.9-3.6-9.5 c-0.4-2.7-0.4-5.5,0.2-8.2c0.1-0.6,0.2-1.1,0.4-1.7C149.9,13.5,151.3,11.1,152.3,9.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.5-0.8c-7.7,0-14,6.2-14,13.9c0,4,1.7,7.7,4.5,10.2l-1.1,1.2c-3.1-2.8-5.1-6.9-5.1-11.4 c0-8.6,7-15.5,15.7-15.5c7,0,13,4.6,15,10.9l-1.6,0.5C151.1,3.3,145.8-0.8,139.5-0.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.6,23.1c2.7-2.6,6.4-4.2,10.4-4.2c1.5,0,2.9,0.2,4.2,0.6l-0.5,1.6c-1.2-0.4-2.5-0.5-3.8-0.5 c-3.6,0-6.9,1.4-9.3,3.7l0,0l0,0c-2.7,2.6-4.5,6.3-4.5,10.4c0,7.8,6.2,14.1,13.8,14.1c6.9,0,12.7-5.3,13.6-12.1l1.6,0.2 c-1.1,7.7-7.5,13.6-15.3,13.6c-8.5,0-15.4-7.1-15.4-15.8C123.6,30.1,125.5,26,128.6,23.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49.8,25.5c0,13.4-10.9,24.3-24.3,24.3S1.2,38.9,1.2,25.5S12.1,1.2,25.5,1.2S49.8,12.1,49.8,25.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M135.3,10.6c0.8,0,1.4-1.2,1.4-2.8c0-1.5-0.6-2.8-1.4-2.8c-0.8,0-1.4,1.2-1.4,2.8 C133.9,9.3,134.5,10.6,135.3,10.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M19,24c1.2,0,2.2-2,2.2-4.4s-1-4.4-2.2-4.4c-1.2,0-2.2,2-2.2,4.4S17.7,24,19,24z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M142.7,10.6c0.8,0,1.4-1.2,1.4-2.8c0-1.5-0.6-2.8-1.4-2.8c-0.8,0-1.4,1.2-1.4,2.8 C141.3,9.3,142,10.6,142.7,10.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M134.2,34.6c0.8,0,1.4-1.2,1.4-2.8S135,29,134.2,29s-1.4,1.2-1.4,2.8S133.5,34.6,134.2,34.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M30.8,24c1.2,0,2.2-2,2.2-4.4s-1-4.4-2.2-4.4c-1.2,0-2.2,2-2.2,4.4S29.5,24,30.8,24z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M142.7,34.7c0.8,0,1.4-1.2,1.4-2.8c0-1.5-0.6-2.8-1.4-2.8c-0.8,0-1.4,1.2-1.4,2.8 C141.3,33.5,141.9,34.7,142.7,34.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M34.9,30.7c0.9,0.4,1.3,1.5,0.9,2.5c-1.8,4.3-5.7,7.3-10.1,7.7c-5,0.4-9.7-2.7-11.7-7.7c-0.4-0.9,0-2.1,0.9-2.5 c0.9-0.4,1.9,0,2.3,1c1.5,3.5,4.8,5.7,8.3,5.4h0c3-0.2,5.8-2.3,7.1-5.4C33,30.7,34,30.3,34.9,30.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.9,41.3c0-0.6,0.4-1,0.8-1h8.7c0.4,0,0.8,0.5,0.8,1c0,0.6-0.4,1-0.8,1h-8.7 C134.2,42.3,133.9,41.9,133.9,41.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositive);
export default __webpack_public_path__ + "static/media/positive.2304cbb1cea771d98627d64b1ee7d4df.svg";
export { ForwardRef as ReactComponent };